/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Pricing_Per_YearInputs */

const en_platform_pricing_per_year = /** @type {(inputs: Platform_Pricing_Per_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per year`)
};

const pl_platform_pricing_per_year = /** @type {(inputs: Platform_Pricing_Per_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rocznie`)
};

/**
* | output |
* | --- |
* | "per year" |
*
* @param {Platform_Pricing_Per_YearInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_pricing_per_year = /** @type {((inputs?: Platform_Pricing_Per_YearInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Pricing_Per_YearInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_pricing_per_year(inputs)
	return en_platform_pricing_per_year(inputs)
});